import React from "react";
import "./GanttRender.css";


const CustomTaskListHeader: React.FC = () => {
    return (
        <div className="_3eULf" tabIndex={0}>
            <div>
                <div className="gant_render--taskListHeader">
                    <div className="_1nBOt" style={{ height: "50px" }}>
                        <div className="_WuQ0f gant_render-head-text" style={{ minWidth: "100px" }}>Номер</div>
                        <div className="_2eZzQ gant_render-head-text" style={{ height: "25px", marginTop: "10px" }}></div>
                        <div className="_WuQ0f gant_render-head-text" style={{ width: "190px", padding:"5px" }}>Наименование задачи</div>
                        <div className="_2eZzQ gant_render-head-text" style={{ height: "25px", marginTop: "10px" }}></div>
                        <div className="_WuQ0f gant_render-head-text" style={{ minWidth: "100px", padding:"5px" }}>Дата начала</div>
                        <div className="_2eZzQ gant_render-head-text" style={{ height: "25px", marginTop: "12.5px" }}></div>
                        <div className="_WuQ0f gant_render-head-text" style={{ minWidth: "120px", padding:"5px" }}>Дата окончания</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomTaskListHeader;